//import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { authConfig } from "./authConfig";
import App from './App';
import { unregister as unregisterServiceWorker } from './registerServiceWorker'
import './i18n';
import { ErrorHandler } from './components/ErrorHandler';
import { BrowserRouter } from 'react-router-dom';
import { Loader } from '@progress/kendo-react-indicators';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);
const msalInstance = new PublicClientApplication(authConfig);

ReactDOM.render(
    <ErrorHandler>
        <Provider store={store}>
            <BrowserRouter>
                <MsalProvider instance={msalInstance}>
                <React.Suspense fallback={<div/>}>
                        <App />
                    </React.Suspense>
                </MsalProvider>
            </BrowserRouter>
        </Provider>
    </ErrorHandler>
    ,
    document.getElementById('root'));
//disable caching
unregisterServiceWorker();
